import SettingsPage from '@/features/companies/[companyId]/settings/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/companies/$companySlug/settings')({
  component: SettingsPage,
})
